import { render, staticRenderFns } from "./xpgy.vue?vue&type=template&id=48554ad5&scoped=true"
import script from "./xpgy.vue?vue&type=script&lang=js"
export * from "./xpgy.vue?vue&type=script&lang=js"
import style0 from "./xpgy.vue?vue&type=style&index=0&id=48554ad5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48554ad5",
  null
  
)

export default component.exports